import api from "@/api";

export default {
    namespaced: true,
    state: () => ({
        guardians: [],
            guardianStudents: [],
        currentGuardian: null,
        isLoading: false,
        error: null,
        filters: {
            search: '',
            gender: null,
            relation: null
        },
        pagination: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            perPage: 10,
            from: 0,
            to: 0
        }
    }),
    mutations: {
        SET_GUARDIANS(state, guardians) {
            state.guardians = guardians;
        },
          setGuardianStudents(state, students) {
      state.guardianStudents = students;
    },
        SET_CURRENT_GUARDIAN(state, guardian) {
            state.currentGuardian = guardian;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_FILTERS(state, filters) {
            state.filters = { ...state.filters, ...filters };
        },
        SET_PAGINATION(state, pagination) {
            state.pagination = { ...state.pagination, ...pagination };
        },
        RESET_FILTERS(state) {
            state.filters = {
                search: '',
                gender: null,
                relation: null
            };
        },
        ADD_GUARDIAN(state, guardian) {
            state.guardians.unshift(guardian);
        },
        UPDATE_GUARDIAN(state, updatedGuardian) {
            const index = state.guardians.findIndex(g => g.id === updatedGuardian.id);
            if (index !== -1) {
                state.guardians.splice(index, 1, updatedGuardian);
            }
        },
        DELETE_GUARDIAN(state, guardianId) {
            state.guardians = state.guardians.filter(g => g.id !== guardianId);
        },
        SET_GUARDIAN_STUDENTS(state, students) {
            state.guardianStudents = students;
          }
    },
    actions: {
        async fetchGuardians({ commit, state }, { page = 1, perPage = 10 } = {}) {
            try {
                commit('SET_LOADING', true);
                const params = {
                    page,
                    per_page: perPage,
                    ...state.filters
                };

                const response = await api.get('/guardians', { params });
                
                commit('SET_GUARDIANS', response.data.data);
                commit('SET_PAGINATION', {
                    currentPage: response.data.meta.current_page,
                    totalPages: response.data.meta.last_page,
                    totalItems: response.data.meta.total,
                    perPage: response.data.meta.per_page,
                    from: response.data.meta.from,
                    to: response.data.meta.to
                });
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async fetchGuardian({ commit }, guardianId) {
            try {
                commit('SET_LOADING', true);
                const response = await api.get(`/guardians/${guardianId}`);
                commit('SET_CURRENT_GUARDIAN', response.data.data || response.data);
                return response.data.data || response.data;
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async createGuardian({ commit }, guardianData) {
            try {
                commit('SET_LOADING', true);
                const response = await api.post('/guardians', guardianData);
                commit('ADD_GUARDIAN', response.data);
                return response.data;
            } catch (error) {
                if (error.response?.status === 422) {
                    throw error;
                }
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async updateGuardian({ commit }, { id, guardianData }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.put(`/guardians/${id}`, guardianData);
                commit('UPDATE_GUARDIAN', response.data);
                return response.data;
            } catch (error) {
                if (error.response?.status === 422) {
                    throw error;
                }
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
      async deleteGuardian({ commit }, guardianId) {
  commit('SET_LOADING', true);
  try {
    const resp = await api.delete(`/guardians/${guardianId}`);
    commit('DELETE_GUARDIAN', guardianId);
    return { success: true, status: resp?.status ?? 204 };
  } catch (error) {
    const status = error?.response?.status ?? 500;
    const apiMsg =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      (error.message ?? null);

    commit('SET_ERROR', apiMsg || 'Failed to delete guardian');

    throw { status, message: apiMsg || 'Failed to delete guardian' };
  } finally {
    commit('SET_LOADING', false);
  }
},
        
        async fetchAllGuardians({ commit }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.get('/guardians/all');
                return response.data.data || response.data;
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        async fetchGuardianStudents({ commit }, guardianId) {
            try {
              commit('SET_LOADING', true);
              const response = await api.get(`/guardians/${guardianId}/students`);
              commit('SET_GUARDIAN_STUDENTS', response.data.data);
            } catch (error) {
              commit('SET_ERROR', error.response?.data?.message || error.message);
              throw error;
            } finally {
              commit('SET_LOADING', false);
            }
          },
        
          async updateGuardianStudentRelation({ commit }, { guardianId, studentId, relationType }) {
            try {
              commit('SET_LOADING', true);
              const response = await api.put(`/guardians/${guardianId}/students/${studentId}`, {
                relation_type: relationType
              });
              return response.data;
            } catch (error) {
              commit('SET_ERROR', error.response?.data?.message || error.message);
              throw error;
            } finally {
              commit('SET_LOADING', false);
            }
          },
        
          async removeGuardianStudent({ commit }, { guardianId, studentId }) {
            try {
              commit('SET_LOADING', true);
              await api.delete(`/guardians/${guardianId}/students/${studentId}`);
              return { success: true };
            } catch (error) {
              commit('SET_ERROR', error.response?.data?.message || error.message);
              throw error;
            } finally {
              commit('SET_LOADING', false);
            }
          }
        
    },
    getters: {
        filteredGuardians: state => state.guardians,
        isLoading: state => state.isLoading,
        getError: state => state.error,
        getFilters: state => state.filters,
        getPagination: state => state.pagination,
        getCurrentGuardian: state => state.currentGuardian,
        guardianStudents: state => state.guardianStudents

    }
};